import React from "react";
import { useTranslation } from "react-i18next";
import { Icon } from "@iconify/react";

/**
 * Not Found page displayed when a user navigates to
 * a route that doesn't exist.
 */
export const NotFoundPage: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col items-center justify-center min-h-[60vh] px-4">
      <div className="flex flex-col items-center text-center max-w-md">
        {/* Search Icon */}
        <div className="flex items-center justify-center w-20 h-20 rounded-full mb-6 bg-default-100">
          <Icon className="w-10 h-10 text-brand-primary" icon="solar:magnifer-broken" />
        </div>

        {/* Title */}
        <h1 className="text-2xl font-bold mb-2 text-brand-primary">{t("Page Not Found")}</h1>

        {/* Message */}
        <p className="text-default-500 mb-8">{t("Page Not Found Message")}</p>
      </div>
    </div>
  );
};
